import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onClick, ...props }, ref) => {
    const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
      onClick?.(event);
      if (
        type === "date" ||
        type === "time" ||
        type === "datetime-local" ||
        type === "month" ||
        type === "week"
      ) {
        event.currentTarget.showPicker?.();
      }
    };

    return (
      <input
        type={type}
        ref={ref}
        onClick={handleClick}
        className={cn(
          "flex h-10 w-full rounded-md border border-white/10 bg-slate-950/60 px-3 py-2 text-base text-slate-100 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-slate-100 placeholder:text-slate-500 focus-visible:outline-none focus-visible:border-emerald-400/60 focus-visible:ring-emerald-400/25 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-colors",
          className
        )}
        {...props}
      />
    );
  }
)
Input.displayName = "Input"

export { Input }
